<template>
  <v-card>
    <v-card-text>
      <v-data-table
        v-bind="dataTableAttrs"
        :headers="headersShown"
        :items="list"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="total"
        :items-per-page.sync="itemsPerPage"
        v-model="selectedItems"
        @update:items-per-page="handleItemsPerPageUpdated"
        :show-select="false"
      >
        <template v-slot:top>
          <rs-table-title-bar
            v-if="$refs.headSearch"
            title="Ödeme Transfer Takip Listesi"
            icon="mdi-cash-check"
            :add-route="null"
            @clear-filters="$refs.headSearch.reset"
            @reload="loadList"
            hide-edit
            :search.sync="search.query"
            v-bind="titleBarAttrs"
          ></rs-table-title-bar>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.prepend="{ headers }">
          <rs-table-head-search
            :headers="headers"
            :search.sync="search"
            ref="headSearch"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.append="{ headers }">
          <rs-table-foot-totals
            :headers="headers"
            :totals="footTotals"
            v-if="list.length > 0"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.cluster_name="{ item }">
          <router-link
            :to="{
              name: 'definitions.clusters.edit',
              params: { id: item.cluster_id },
              hash: '#cc',
            }"
          >
            {{ item.cluster_name }}
          </router-link>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.is_ok="{ value }">
          <rs-table-cell-boolean :value="value" />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.payment_amount="{ item, value }">
          <router-link
            :to="{
              name: 'activities.cc-payments.list',
              query: {
                cluster_id: item.cluster_id,
                is_success: true,
              },
            }"
          >
            <rs-table-cell-number price :value="value" />
          </router-link>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.transfer_amount="{ item, value }">
          <router-link
            :to="{
              name: 'activities.banks.list',
              query: {
                cluster_id: item.cluster_id,
                bill_type: 'transfer',
                bank_safe: 'pos',
              },
            }"
          >
            <rs-table-cell-number price :value="value" />
          </router-link>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { filtersToURL, hasExport, hasPermissions } from "@/view/mixins";
import { mapGetters } from "vuex";

export default {
  mixins: [filtersToURL, hasExport, hasPermissions],
  computed: {
    ...mapGetters(["roleList"]),
  },
  data() {
    return {
      options: {
        sortBy: ["is_ok"],
        sortDesc: [true],
      },
      search: {
        is_ok: false,
      },
      headers: [
        {
          text: "TYA",
          value: "cluster_name",
          searchable: "text",
        },
        {
          text: "Başarılı Ödeme Tutarı",
          value: "payment_amount",
          searchable: "number",
          align: "end",
        },
        {
          text: "Transfer Tutarı",
          value: "transfer_amount",
          searchable: "number",
          align: "end",
        },
        {
          text: "Doğru",
          value: "is_ok",
          searchable: "yesNo",
          align: "center",
        },
      ],
      titleBarAttrs: {
        exportUrl: () => "api-super-admin/payout-check",
        exportParams: this.getParams,
      },
    };
  },
  mounted() {
    this.generateExportColumns(this.headers);
  },
  methods: {
    getParams() {
      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      return params;
    },
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];
      this.footTotals = [];

      const params = this.getParams();

      this.$api
        .query("api-super-admin/payout-check", { params })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  watch: {
    options: {
      handler() {
        this.setURLParams();
      },
      deep: true,
    },
    search: {
      handler: debounce(function () {
        this.options.page = 1;
        this.setURLParams();
      }, 250),
      deep: true,
    },
  },
};
</script>
